module.exports = __webpack_public_path__ + "static/media/exclamation.f9184224.svg";